<template>
  <div class="account-notifications">
    <div class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
        <tr>
          <th width="100"><a href="javascript:;">DATE</a></th>
          <th width="100"><a href="javascript:;">JOB NO</a></th>
          <th><a href="javascript:;">DESCRIPTION</a></th>
        </tr>
        </thead>
        <tbody>
        <tr><td colspan="3">No notifications.</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ServiceUser from '@/services/user'

  export default {
    data () {
      return {
        loading: false,
        notifications: [],
        totalItems: 0
      }
    },
    watch: {},
    computed: {
      ...mapGetters(['IS_CLIENT', 'CURRENT_USER'])
    },
    mounted () {
      this.init();
    },
    methods: {
      init() {
        this.getNotifications();
      },
      _getParams(){
        let self = this,
          params = {
            ipp: 'all',
            status: 'requested'
          };

        if(self.IS_CLIENT){
          params['client_id'] = self.CURRENT_USER.client_id;
        }
        return params;
      },
      getNotifications () {
        let self = this, params = self._getParams();
        self.loading = true;
        ServiceUser.getNotifications(params, resp => {
          self.notifications = resp;
          self.loading = false;
          self.totalItems = window.numkeys(self.notifications);
        });
      }
    }
  }
</script>
